module.exports = __webpack_public_path__ + "static/media/banner.9ab10368.mp4";